import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger);

// Toggle Image
function toggleImageClass() {
    const images = document.querySelectorAll(".imagetotoggle");
    images.forEach((image) => {
        const imageRect = image.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const imageMiddle = imageRect.top + imageRect.height / 2;
        const windowMiddle = windowHeight / 2;

        if (imageMiddle <= windowMiddle) {
            image.classList.add("imageisactive");
        }
    });
}
window.addEventListener("scroll", toggleImageClass);
// End Toggle Image

// Parallax effect
const tlp = gsap.timeline();
tlp.to(".parallaxheader img", {
    yPercent: -20,
    ease: "power1.out",
    scrollTrigger: {
        trigger: ".parallaxheader",
        start: "top top+=124px",
        end: "bottom top",
        scrub: true,
        markers: false,
    },
});
// End Parallax effect
// text effects with css
$(document).ready(function () {
    var h = new IntersectionObserver(function (t, e) {
        t.forEach(function (t) {
            t.isIntersecting && t.target.classList.add("slide-up");
        });
    });
    document.querySelectorAll(".animate").forEach(function (t) {
        h.observe(t);
    });
});
// end text effects with css


// remove lazy load images

addEventListener("load", () => {
    $("img[loading='lazy']").each(function () {
        $(this).addClass("lazyimg");
    });

    $(window).scroll(function () {
        $(".lazyimg").each(function () {
            if (isScrolledIntoView($(this))) {
                $(this).removeClass("lazyimg");
                $(this).prop("loading", "eager");
                //ScrollTrigger.refresh();
                window.dispatchEvent(new Event("resize"));
            }
        });
    });

    function isScrolledIntoView(elem) {
        var $elem = $(elem);
        var $window = $(window);

        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();

        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();

        return elemBottom <= docViewBottom + 100 || elemTop >= docViewTop - 100; //false oder true
    }
});

// end remove lazy loas images
